import { render } from "./indexEmail.vue?vue&type=template&id=1595130c"
import script from "./indexEmail.vue?vue&type=script&lang=js"
export * from "./indexEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__